export enum APP_ROUTES {
    APP_SELECTION = 'app-selection',
}